module.exports = __webpack_public_path__ + "static/media/king_of_clubs.ff456a80.svg";